import { render, staticRenderFns } from "./WDialogView.vue?vue&type=template&id=7634b5ac&"
import script from "./WDialogView.vue?vue&type=script&lang=ts&"
export * from "./WDialogView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports